import * as React from 'react'
import { Modal, Button } from 'react-bootstrap'
/*
    this class is the pop up page when you click in the button sign up
*/
interface InscriptionProps {
    ChangeViewToConnexion: () => void
    ChangeViewToPasswordForgot: () => void
    updateEmail: (e: React.FormEvent<HTMLInputElement>) => void
    updatePassword: (e: React.FormEvent<HTMLInputElement>) => void
    updatePasswordVerify: (e: React.FormEvent<HTMLInputElement>) => void
}

interface InscriptionState {
    EmailInscription: string,
    PasswordInscription: string,
    PasswordConfirmInscription: string
}

export default class InscriptionModal extends React.Component<InscriptionProps, InscriptionState> {

    render() {
        return (
        <>
            <Modal.Body>
                <div className="form-group">
                    <b>Adresse e-mail</b>
                    <input className="form-control"
                        type="email"
                        placeholder="Entrer votre adresse e-mail" 
                        onInput={this.props.updateEmail}></input>
                </div>

                <div className="form-group">
                    <b>Mot de passe</b>
                    <input className="form-control"
                        //type="search"
                        type="password"
                        placeholder="Entrer votre mot de passe" 
                        onInput={this.props.updatePassword}></input>
                </div>

                <div className="form-group">
                    <b>Confirmer votre mot de passe</b>
                    <input className="form-control"
                        //type="search"
                        type="password"
                        placeholder="Confirmer votre mot de passe" 
                        onInput={this.props.updatePasswordVerify}></input>
                </div>

                <div className="form-group">
                    <Button variant="link"
                    onClick={this.props.ChangeViewToConnexion}
                    ><u>Connexion</u></Button>

                    <Button variant="link"
                    onClick={this.props.ChangeViewToPasswordForgot}
                    ><u>Vous avez oublié votre mot de passe ?</u></Button>
                </div>
            </Modal.Body>
        </>
        );
    }

}